import { DeliveryStatus } from '../../../../../../services/exports/Constants';

export default {
  title: 'Ulkoiset toimitukset',
  fields: {
    pickup: 'Nouto',
    dropoff: 'Toimitus',
    status: 'Tila',
    estimated_time: 'Arvioitu aika',
    actual_time: 'Todellinen aika',
    actions: 'Toiminnot',
    time: 'Aika',
    pickup_estimate: 'Noudon arvio',
    dropoff_estimate: 'Toimituksen arvio',
  },
  labels: {
    pickup: 'Nouto',
    dropoff: 'Toimitus',
  },
  delivery_statuses: {
    [DeliveryStatus.Pending]: 'Odottaa kuljettajaa',
    [DeliveryStatus.RunnerAssigned]: 'Kuljettaja osoitettu',
    [DeliveryStatus.OnRoutePickup]: 'Matkalla noutopisteeseen',
    [DeliveryStatus.ArrivedPickup]: 'Saapunut noutopisteeseen',
    [DeliveryStatus.PickedUp]: 'Noudettu',
    [DeliveryStatus.OnRouteDropoff]: 'Matkalla toimituspisteeseen',
    [DeliveryStatus.ArrivedDropoff]: 'Saapunut toimituspisteeseen',
    [DeliveryStatus.Completed]: 'Valmis',
    [DeliveryStatus.Cancelled]: 'Peruttu',
  },
  buttons: {
    actions: 'Toiminnot',
    open_tracking_url: 'Seuraa toimitusta',
    show_order_details: 'Näytä tilauksen tiedot',
    call_restaurant: 'Soita ravintolaan',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
